export const customer = {
    name: 'customer',
    params: {
        searchFields: ['name', 'alias'],
        extraParameters() {}
    }
};
